if (!customElements.get("keyword-related-results")) {
  customElements.define(
    "keyword-related-results",
    class KeywordRelatedResults extends HTMLElement {
      constructor() {
        super();

        this.resultsContainer = this.querySelector(".results-container");
        this.fallbackTemplate = this.querySelector(
          "template[data-related-fallback]"
        );

        if (!this.resultsContainer) return;

        const url = this.constructQueryUrl();

        if (!url) {
          this.renderFallback();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            this.fetchContent(url);
          },
          { rootMargin: "0px 0px 400px 0px" }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      fetchContent(url) {
        webvista
          .fetchHtml(url)
          .then((html) => this.renderHtml(html))
          .catch(() => this.renderFallback());
      }

      renderHtml(html) {
        const source = html.getElementById(this.id);
        const resultTemplate = source
          ? source.querySelector(
              "template:not([data-related-fallback])"
            )
          : null;

        if (
          resultTemplate &&
          resultTemplate.content.querySelector(
            ".results-container > li"
          )
        ) {
          this.replaceResults(resultTemplate);
        } else {
          this.renderFallback();
        }
      }

      renderFallback() {
        if (
          this.fallbackTemplate &&
          this.fallbackTemplate.content.querySelector(
            ".results-container > li"
          )
        ) {
          this.replaceResults(this.fallbackTemplate);
        } else {
          this.remove();
        }
      }

      replaceResults(template) {
        this.resultsContainer.replaceWith(
          template.content.cloneNode(true)
        );

        this.resultsContainer =
          this.querySelector(".results-container");

        if (typeof webvista !== "undefined") {
          if (typeof webvista.initLazyImages === "function") {
            webvista.initLazyImages();
          }
          if (typeof webvista.initTooltips === "function") {
            webvista.initTooltips();
          }
        }
      }

      constructQueryUrl() {
        const query = (this.dataset.keyword || "").trim();
        if (!query) return null;

        const params = new URLSearchParams({
          q: query,
          type: this.dataset.type || "product",
          section_id: this.dataset.section,
          ose: "false"
        });

        return `${this.dataset.searchUrl}?${params.toString()}`;
      }
    }
  );
}
